export default [
  {
    path: "/divisas",
    component: () => import("@/views/divisas/Listar.vue"),
  },
  {
    path: "/divisas/crear",
    component: () => import("@/views/divisas/Crear.vue"),
  },
  {
    path: "/divisas/editar/:id",
    component: () => import("@/views/divisas/Editar.vue"),
  },
  {
    path: "/divisas/editar-tasas/:id",
    component: () => import("@/views/divisas/EditarTasasCambio.vue"),
  },
];
